/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef, useState } from 'react';
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Space } from "antd";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import { Plans, BillingDetails } from "./Blocks";
import {
    getBusinessId, idNamingConversion,
    capitalizeFirstLetter, currencyFormat, currencyFormatInt, checkViewPermission
} from "../../../../../helpers/utilities";
import younoteAdminActions from "../../../../YounoteAdmin/Product/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import adminActions from "../../redux/actions";
import { BlinkedBox } from "../../../../../helpers/utilities";
import { CustomModal } from "../../../../Shared/components/DeleteModal";


const Billings = (props) => {
    const classes = customStyles();
    const { roleManagement } = useSelector(state => state.authReducer);
    const { businessDetails, subscriptionDetails, subscriptionOrder, paymentCheck } = useSelector(state => state.homeReducer);
    const { planDetails, planLoader } = useSelector(state => state.younoteAdminProductReducer);
    const { createDetails, createError, createLoader, createData, editDetails, editError } = useSelector(state => state.crudReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const dispatch = useDispatch();
    const [errorModal, setErrorModal] = useState(false);
    const { history } = props;
    const formRef = useRef('');
    const [error, setError] = useState(false);
    //  const [subscriptionCheck, setSubscriptionCheck] = useState(false);
    const [data, setData] = useState('');
    //const [paymentCheckId, setPaymentCheckId] = useState(''); 
    const [frequency, setFrequency] = useState('YEARLY');
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Billing and Plans', history, 'Admin')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({ type: adminActions.CLEAR_PAYMENT_CHECK_START });
        }
    }, [roleManagement]);


    const loadTasks = () => {
        dispatch({ type: adminActions.SUBSCRIPTION_ORDER_START, businessId: getBusinessId() });
        dispatch({ type: adminActions.SUBSCRIPTION_DETAILS_START });
        dispatch({
            type: younoteAdminActions.PLAN_DETAILS_START, url: 'activePlans', filter: {
                where: { 'frequency': frequency, status: 'ACTIVE' },
                order: 'planId asc'
            }
        });
    }

    const handleSubscription = (data) => {
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: 'subscriptionOrders',
            title: 'Subscriptions',
            details: {
                planId: data?.id,
                businessId: getBusinessId()
            }
        });
    }


    useEffect(() => {
        // if (timeoutRef.current !== null) {
        //     clearTimeout(timeoutRef.current);
        // }
        // if (paymentCheck && paymentCheck?.subscriptionPaymentStatus !== 'CAPTURED') {
        //     timeoutRef.current = setTimeout(() => {
        //         timeoutRef.current = null;
        //         dispatch({ type: adminActions.PAYMENT_CHECK_START, id: paymentCheckId });
        //     }, 10000);
        // } else if (paymentCheck && paymentCheck?.subscriptionPaymentStatus === 'CAPTURED') {
        //     setSubscriptionCheck(false);
        //     setData('');
        //     setPaymentCheckId('');
        //     dispatch({ type: adminActions.SUBSCRIPTION_DETAILS_START });
        //     dispatch({ type: adminActions.SUBSCRIPTION_ORDER_START, businessId: getBusinessId() });
        // }
    }, [paymentCheck]);


    useEffect(() => {
        // if (subscriptionOrder !== '') {
        //     if (subscriptionOrder?.payment?.signature) {
        //         setSubscriptionCheck(true);
        //         //dispatch({ type: adminActions.PAYMENT_CHECK_START, id: subscriptionOrder?.payment?.id });
        //     }
        //     setPaymentCheckId(subscriptionOrder?.payment?.id);
        // }
    }, [subscriptionOrder]);


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (createData?.subscriptionPaymentId) {
                setTimeout(() => {
                    formRef?.current?.payNow();
                }, 100);
                setData(createData);
                // setPaymentCheckId(createData?.subscriptionPaymentId);
                dispatch({ type: adminActions.SUBSCRIPTION_ORDER_START, businessId: getBusinessId() });
            } else {
                toast.dismiss();
                toast('Subscriptions updated successfully.');
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            toast.dismiss();
            toast.error(createError.error.message);
        }
    }, [createDetails, createError]);

    const handleError = (data) => {
        setError(data);
    }


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            if (error) {
                setErrorModal(true);
            } else {
                toast('Plan change is Inprogress, Once completed you be notified.');
            }
            dispatch({ type: adminActions.SUBSCRIPTION_ORDER_START, businessId: getBusinessId() });
            //dispatch({ type: adminActions.PAYMENT_CHECK_START, id: paymentCheckId });
            //setSubscriptionCheck(true);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast.error(editError.error.message);
        }
    }, [editDetails, editError]);


    const handleChangePlan = (data) => {
        setFrequency(data);
        dispatch({
            type: younoteAdminActions.PLAN_DETAILS_START, url: 'activePlans', filter: {
                where: { 'frequency': data },
                order: 'planId asc'
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Billing and Plans', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.planDetails)}>
                <PrimaryCard
                    title={'Billing and Plans'}
                    component={
                        <>
                            <Row >
                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={8}>
                                    <h6 className={clsx(classes.typographyHeader, classes.bold)}>Summary</h6>
                                </Col>
                                <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={16} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <Space direction="horizontal" align="center" className={classes.overlFlowResponsiveDesign}>
                                        <NavLink to={'#'}
                                            id={idNamingConversion('Compare Plans', 'billingsPlans', 'Link')}
                                            onClick={() => formRef?.current?.scrollView()}
                                            className={clsx(classes.AddMoreBtn)}>
                                            Compare Plans
                                        </NavLink>
                                        <NavLink to={'#'}
                                            id={idNamingConversion('Upgrade', 'billingsPlans', 'Link')}
                                            onClick={() => formRef?.current?.scrollView()}
                                            className={clsx(classes.modalBtn)}>
                                            Upgrade
                                        </NavLink>
                                    </Space>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignCenter}>
                                    {
                                        subscriptionOrder?.payment?.subscriptionPaymentStatus === 'PROCESSING' && <BlinkedBox className={clsx(classes.typographyHeader, classes.bold, classes.textalignLeft)}>
                                            Subscription plan update is in Progress. Please visit the page after you receive notification
                                        </BlinkedBox>
                                    }
                                </Col>
                            </Row>
                            <BillingDetails details={subscriptionDetails} capitalizeFirstLetter={capitalizeFirstLetter}
                                classes={classes} currencyFormat={currencyFormat} currencyFormatInt={currencyFormatInt} clsx={clsx} />
                            <Plans ref={formRef} details={planDetails} subscriptionDetails={subscriptionDetails}
                                createLoader={createLoader} handleError={(data) => handleError(data)}
                                frequency={frequency}
                                capitalizeFirstLetter={capitalizeFirstLetter}
                                handleChangePlan={(data) => handleChangePlan(data)}
                                businessDetails={businessDetails}
                                displayData={data}
                                // subscriptionCheck={subscriptionCheck}
                                subscriptionOrder={subscriptionOrder}
                                handleSubscription={(data) => handleSubscription(data)}
                                loader={planLoader} classes={classes} clsx={clsx} currencyFormat={currencyFormat} currencyFormatInt={currencyFormatInt} />
                        </>
                    }
                />
            </div>
            <CustomModal
                title={'Payment Failure'}
                visible={errorModal}
                onClose={() => { setErrorModal(false); setError(false) }}
                noButton={'OK'}
                text={error}
            />
        </React.Fragment>
    )
}

export default Billings;